import { motion } from "framer-motion";

// Line-by-line masked reveal for headings
export const MaskedLines = ({ lines, className = "", delay = 0, lineClass = "" }) => {
  return (
    <span className={className}>
      {lines.map((line, i) => (
        <span key={i} className="block overflow-hidden pb-[0.08em]">
          <motion.span
            className={`block ${lineClass}`}
            initial={{ y: "110%" }}
            animate={{ y: "0%" }}
            transition={{
              duration: 0.9,
              delay: delay + i * 0.12,
              ease: [0.19, 1, 0.22, 1],
            }}
            dangerouslySetInnerHTML={{ __html: line }}
          />
        </span>
      ))}
    </span>
  );
};

// Scroll-triggered fade/rise wrapper
export const Reveal = ({ children, delay = 0, y = 40, className = "", once = true }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once, margin: "-80px" }}
    transition={{ duration: 0.8, delay, ease: [0.19, 1, 0.22, 1] }}
  >
    {children}
  </motion.div>
);
